import type { BlogDocument } from "@/lib/blogs";

const PREVIEW_STORAGE_KEY = "choice-wealth-blog-preview";

export function savePreviewBlog(blog: BlogDocument) {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(PREVIEW_STORAGE_KEY, JSON.stringify(blog));
}

export function readPreviewBlog() {
  if (typeof window === "undefined") {
    return null;
  }

  const raw = window.localStorage.getItem(PREVIEW_STORAGE_KEY);
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as BlogDocument;
  } catch {
    return null;
  }
}
